import { render } from "./TvmWebIframeRedirect.vue?vue&type=template&id=38f94688&scoped=true"
import script from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"
export * from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"

import "./TvmWebIframeRedirect.vue?vue&type=style&index=0&id=38f94688&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f94688"]])

export default __exports__